import React from "react";
import "./Experience.css";
import buyer from "./Media/Premium .Gold Domain.png";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fade from "react-reveal/Fade";
import { Buyers } from "./Experience";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const ExperienceCard = () => {
  return (
    <div className="pattern-bg2 ">
      <div className=" container a-container !pt-[3rem] !pb-[0rem]">
        <div className="pb-[3rem] !text-center ">
          <Fade bottom opposite={true} exit={true}>
            <h2 className="font-bold lg:text-5xl md:text-3xl text-2xl my-2 title mb-[25px]   !leading-[140%] !text-center">
              Unlock the Value of your
              <span className="text-pent"> Domains</span>
            </h2>
            <p className=" mx-auto text-base paragraph">
              Experience unmatched expertise and meticulously selected domains
              that ensure you stand out in the digital landscape.
            </p>
          </Fade>
        </div>

        <Fade bottom>
          <div className="buyers-sellers-div">
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 0, borderColor: "divider" }}></Box>
              {/* <Shapes /> */}
              <div className="buyers-sellers-tabscreen">
                <div className="buyers-sellers-tabscreen-img">
                  <img src={buyer} alt="" className="buyer-seller-img-inner" />
                </div>
                <div className="buyers-sellers-tabscreen-content">
                  {Buyers.map((item) => (
                    <div
                      className="buyers-sellers-tabscreen-content-inner-box"
                      key={item.id}
                    >
                      <div className="flex justify-between items-center flex-col md:flex-row flex-col-reverse gap-[12px] !w-fit mb-[8px] ">
                        <Fade left delay={500}>
                          <span className=" text-pent icon-process text-[28px] icon-process p-[8px] rounded-[30px]">
                            {item.icon}
                          </span>
                          <h1 className="heading !text-left ">{item.title}</h1>
                        </Fade>
                      </div>
                      <Fade left delay={750}>
                        <p className="paragraph experience-para">
                          {item.description}
                        </p>
                      </Fade>
                    </div>
                  ))}
                </div>
              </div>
            </Box>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default ExperienceCard;
